// リクルートサイトでのJavascriptのエントリーポイント
import("./entry.js");
import("./entry_confirm.js");
import("./headers.js");
import("./mv_animation.js");
